<mat-card appearance="outlined" class="no-print">
  <mat-toolbar>
    <a mat-stroked-button class="icon-only" routerLink="/home">
      <mat-icon>home</mat-icon>
    </a>
    <span>{{ routeTitle }}</span>
    <button mat-stroked-button class="icon-only" [matMenuTriggerFor]="menu" [matBadge]="1" matBadgePosition="before" [matBadgeHidden]="mfaEnabled || !mfaReminderSupressed">
      <mat-icon> menu </mat-icon>
    </button>
  </mat-toolbar>
</mat-card>

<mat-menu #menu="matMenu" >
  <a mat-menu-item routerLink="/home">Home</a>
  <a mat-menu-item routerLink="/inbox">Inbox</a>
  <a mat-menu-item routerLink="/sent">Sent</a>

  @if (clientMatterContactDetails && clientMatterContactDetails.isMatterBased) {
    <a mat-menu-item routerLink="/matters">Matters</a>
  }

  <a mat-menu-item routerLink="/change-password">Change Password</a>

  @if(!mfaLoading){
    @if(mfaEnabled){
      @if (!isMfaEnforced) {
      <a mat-menu-item routerLink="/mfa-remove">Remove 2FA</a>
      }
    }
    @else {
      <a mat-menu-item routerLink="/mfa-setup">
        <span [matBadge]="1" matBadgePosition="after" matBadgeOverlap="false" [matBadgeHidden]="!mfaReminderSupressed">Setup 2FA</span>
      </a>
    }
  }

  <button mat-menu-item (click)="logOut()">Log Out</button>
</mat-menu>
